import { PLATFORM } from 'aurelia-framework';

export const tabRoutes = [
  {
    route: [''],
    name: 'tab-navision',
    moduleId: PLATFORM.moduleName('./wash-tab-navision'),
    tabindex: 0,
    entityShortName: 'wash-tab-navision',
  },
  {
    route: ['/delta'],
    name: 'tab-delta',
    moduleId: PLATFORM.moduleName('./wash-tab-delta'),
    tabindex: 1,
    entityShortName: 'wash-tab-delta',
  },
  {
    route: ['/xledger'],
    name: 'tab-xledger',
    moduleId: PLATFORM.moduleName('./wash-tab-xledger'),
    tabindex: 2,
    entityShortName: 'wash-tab-xledger',
  },
  {
    route: ['/bcvoninrefa'],
    name: 'tab-bcvoninrefa',
    moduleId: PLATFORM.moduleName('./wash-tab-bcvoninrefa'),
    tabindex: 3,
    entityShortName: 'wash-tab-bcvoninrefa',
  },
  {
    route: ['/bcfaroeislands'],
    name: 'tab-bcfaroeislands',
    moduleId: PLATFORM.moduleName('./wash-tab-bcfaroeislands'),
    tabindex: 4,
    entityShortName: 'wash-tab-bcfaroeislands',
  },
];
